type SpeechOptions = {
  language?: string;
  rate?: number;
  pitch?: number;
};

export function speak(text: string, options: SpeechOptions = {}): void {
  if (!window.speechSynthesis) {
    return;
  }
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = options.language ?? 'en-US';
  utterance.rate = options.rate ?? 1;
  utterance.pitch = options.pitch ?? 1;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utterance);
}

export function stop(): void {
  window.speechSynthesis?.cancel();
}
